import type { TimelineItemProps } from "./types";

import { TimelineItemSimplified } from "./TimelineItemSimplified";

export function TimelineItem(props: TimelineItemProps) {
    return <TimelineItemSimplified {...props} />;
}
